var map = {
	"./czech/lang.js": 44674,
	"./dutch/lang.js": 79689,
	"./english/lang.js": 65375,
	"./french/lang.js": 80469,
	"./german/lang.js": 70223,
	"./italian/lang.js": 48679,
	"./korean/lang.js": 18705,
	"./lithuanian/lang.js": 20392,
	"./polish/lang.js": 92914,
	"./portuguese/lang.js": 15914,
	"./russian/lang.js": 62728,
	"./spanish/lang.js": 79207,
	"./sweden/lang.js": 57485,
	"./ukrainian/lang.js": 78373
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53957;